import * as React from "react";
import { RichTextArea } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css             */
import { withBreakpointVisibility } from "../../../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../../../hocs/hocs/with-anchor.js";
import { useBloomreachRichText } from "../../../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsRowText = ({ component, page }) => {
  const { horizontalAlignment, verticalAlignment, ...cssStyles } = component?.getParameters();
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const { document: documentRef } = component.getModels();
  const document = page?.getContent(documentRef);
  const content = document?.getData();
  const richText = useBloomreachRichText(content.content?.value);
  const rowTextClassName = generateConditionalClassNames("br-row-text", {
    horizontalAlignment,
    verticalAlignment
  });
  if (!content || !richText) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: rowTextClassName, "data-t": "br-row-text", style: filteredStyles }, /* @__PURE__ */ React.createElement(RichTextArea, { content: richText }));
};
const RowText = compose(withBreakpointVisibility, withAnchor)(CmsRowText);
export {
  CmsRowText,
  RowText as default
};
//# sourceMappingURL=RowText.js.map
